import { Loader2, AlertCircle, Radio } from 'lucide-react';
import classes from '../ControlBar/ControlBar.module.css';

interface StreamingButtonProps {
  status: 'IDLE' | 'IN_PROGRESS' | 'LOADING' | 'FAILED' | 'PARTIALLY_FAILED';
  onStartStreaming: () => void;
  onStopStreaming?: () => void;
  stopFailed?: boolean;
}

export const StreamingButton = ({
  status,
  onStartStreaming,
  onStopStreaming,
  stopFailed = false,
}: StreamingButtonProps) => {
  const getButtonContent = () => {
    switch (status) {
      case 'IDLE':
        return {
          icon: <Radio size={20} />,
          text: 'Live',
          disabled: false,
          onClick: onStartStreaming,
        };
      case 'LOADING':
        return {
          icon: <Loader2 size={20} className={classes.loadingIcon} />,
          text: 'Loading',
          disabled: true,
          onClick: () => {},
        };

      case 'IN_PROGRESS':
        return {
          icon: <Radio size={20} className={classes.activeIcon} />,
          text: 'Live',
          disabled: false,
          onClick: onStopStreaming,
        };
      case 'FAILED':
        return {
          icon: <AlertCircle size={20} />,
          text: stopFailed ? 'Retry stop' : 'Failed',
          disabled: false,
          onClick: stopFailed ? onStopStreaming : onStartStreaming,
        };
      case 'PARTIALLY_FAILED':
        return {
          icon: <AlertCircle size={20} />,
          text: stopFailed ? 'Retry stop' : 'Live',
          disabled: false,
          onClick: stopFailed ? onStopStreaming : onStartStreaming,
        };
    }
  };

  const { icon, text, disabled, onClick } = getButtonContent();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-status={status}
      className={`lk-button ${classes.button}`}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
};
